class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.setHeaderCartIconAccessibilityy();
  }

   setHeaderCartIconAccessibility() {
    /*const cartLink = document.querySelector('#cart-icon-bubbl');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });*/
  }
  setHeaderCartIconAccessibilityy() {
    const cartLinkk = document.querySelector('#cart-icon-bubblee');
    cartLinkk.setAttribute('role', 'button');
    cartLinkk.setAttribute('aria-haspopup', 'dialog');
    cartLinkk.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLinkk)
    });
    cartLinkk.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLinkk);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  connectedCallback() {
    this.addEventListener('click', this.onClickHandler.bind(this));
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  onClickHandler(event) {
    const button = event.target.closest('button');
    if (!button) return;

    const cartItem = button.closest('[data-cart-item]');
    if (!cartItem) return;

    const line = parseInt(cartItem.dataset.index, 10); // Shopify's 1-based line index
    const quantityInput = cartItem.querySelector('.quantity__input');
    let quantity = parseInt(quantityInput.value, 10);

    // Quantity change
    if (button.classList.contains('quantity__button')) {
      if (button.classList.contains('plus')) {
        quantity += 1;
      } else if (button.classList.contains('minus')) {
        quantity = Math.max(0, quantity - 1);
      }

      this.updateQuantity(line, quantity);
    }

    // Remove item
    if (button.classList.contains('cart-remove-button')) {
      this.updateQuantity(line, 0);
    }
  }

updateQuantity(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ line, quantity })
  })
    .then(res => res.json())
    .then((cartState) => {
      const sections = this.getSectionsToRender();
      const sectionPromises = sections.map(section => {
        const url = `/?section_id=${section.section}`;
        return fetch(url)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newContent = doc.querySelector(section.selector);
            const container = document.querySelector(section.selector);
            if (container && newContent) {
              container.innerHTML = newContent.innerHTML;
            }
          });
      });

      Promise.all(sectionPromises).then(() => {
        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer) {
          const isEmpty = cartState.item_count === 0;

          // Add 'is-empty' class to the cart drawer if it's empty
          cartDrawer.classList.toggle('is-empty', isEmpty);

          // Display the empty cart state (your design should handle this in the 'is-empty' state)
          const cartEmptyMessage = document.querySelector('.drawer__inner-empty');
          if (cartEmptyMessage && isEmpty) {
            cartEmptyMessage.style.display = 'block'; // Or toggle visibility based on your design
          }
        }
      });
    })
    .catch((error) => {
      console.error('Error updating quantity:', error);
    });
}


  renderUpdatedSections() {
    const sections = this.getSectionsToRender();
    const sectionPromises = sections.map(section => {
      const url = `/?section_id=${section.section}`;
      return fetch(url)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector(section.selector);
          const container = document.querySelector(section.selector);
          if (container && newContent) {
            container.innerHTML = newContent.innerHTML;
          }
        });
    });

    Promise.all(sectionPromises).then(() => {
      document.querySelector('cart-drawer').open();
    });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
